export default "__VITE_ASSET__393f5a36__"